<template>
  <section class="home">
    <Loading/>
    <Toast :show="$bus.toast.show"/>
    <section class="main">
      <ff-header/>
      <div class="inner">
        <Pool class="home-pool"/>
        <ff-main class="home-main" :class="$bus.firstLoading ? 'hidden' : ''" :shuffle="$bus.shuffleAnime&&!alertShow" :flipAnime="$bus.flipAnime"/>
      </div>
    </section>
    <Confirm/>
    <Reward/>
    <Rule/>
    <History/>
    <Alert :show.sync="alertShow" :title="alertTitle" :content="alertContent"/>
    <EuPolicyAlert :show.sync="euPolicyShow" :content="euPolicyContent" :storageText="euPolicyChoiceContent.storageText" :adText="euPolicyChoiceContent.adText"></EuPolicyAlert>

  </section>
</template>
<script>
import { setSessionStorage, getSessionStorage, initGA, addGA, errorGA } from '@/utils/assist'
import Toast from '@/components/common/Toast.vue'
import Loading from '@/components/common/Loading.vue'
import ffHeader from '@/components/common/Header.vue'
import Pool from '@/components/pool/'
import ffMain from '@/components/main/'
import Confirm from '@/components/confirm/'
import Rule from '@/components/rule/'
import History from '@/components/history/'
import Reward from '@/components/reward/'
import Alert from "@/components/alert/Alert.vue"
import { eu_data, euPopupInject } from '@/utils/eu_popup'
import EuPolicyAlert from '@/components/base/EuPolicyAlert.vue'

export default {
  name: 'home',
  data () {
    return {
      globalConfig: this.$bus.$data, // 全局被观测数据对象
      alertShow: false,
      alertTitle: '',
      alertContent: '',
      ...eu_data
    }
  },
  components: {
    Loading,
    Toast,
    ffHeader,
    Pool,
    ffMain,
    Confirm,
    Rule,
    History,
    Reward,
    Alert,
    EuPolicyAlert
  },
  methods: {
    initInfo () {
      let accessToken = getSessionStorage(`${PROJECT_NAME}AccessToken`) || ''
      let lang = getSessionStorage(`${PROJECT_NAME}Lang`) || ''
      if (!accessToken) return this.$bus.handleError('TOAST_LOGIN_FAILED')
      this.$api
        .info({
          access_token: accessToken,
          lang: lang
        })
        .then(response => {
          let data = response.data
          let dataLogName = data['data_log_name']
          console.log(data)
          this.$bus.uid = data.player.uid
          this.$bus.gems = data.player.gems
          this.$bus.transify = data.transify
          this.$bus.rule.content = data.common_config.rule
          this.$bus.setRewardPool(data.rewards)
          this.$bus.setActInfo(data.player, data.common_config)
          if (data.player.init) {
            localStorage.removeItem(`${PROJECT_NAME}_load_${this.$bus.uid}`)
            localStorage.removeItem(`${PROJECT_NAME}_flipIdxs_${this.$bus.uid}`)
          }
          this.googleAnalyticsPopupInject(data)
          if (data['policy_popup']) {
            const { popup_title: policyTitle, popup_content: policyCtx, checked: policyHide } = data['policy_popup']
            this.alertShow = !policyHide
            this.alertTitle = policyTitle
            this.alertContent = policyCtx
          }
          this.initNotice()
          document.body.setAttribute('data-lang', data.common_config.lang)
          initGA(data.common_config.region, this.$bus.uid, dataLogName)
        })
    },
    initNotice () {
      let flipNotice = localStorage.getItem(`${PROJECT_NAME}_flip_${this.$bus.uid}`)
      let refreshNotice = localStorage.getItem(`${PROJECT_NAME}_refresh_${this.$bus.uid}`)
      let skipAnime = localStorage.getItem(`${PROJECT_NAME}_skip_${this.$bus.uid}`)
      let firstLoad = localStorage.getItem(`${PROJECT_NAME}_load_${this.$bus.uid}`)
      this.$bus.flipNotice = flipNotice !== 'false'
      this.$bus.refreshNotice = refreshNotice !== 'false'
      this.$bus.skipAnime = skipAnime === 'true'
      this.$bus.firstLoad = firstLoad !== 'false'
    },
    googleAnalyticsPopupInject: euPopupInject,
  },
  mounted () {
    this.initInfo()
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-position-y: top;
  .main {
    width: 100%;
    height: 100%;
    @include flexcc;
  }
}
.inner {
  position: relative;
  width: 100%;
  @include flexrc;
  @include px2res(margin-top, 72);
}
.home-pool {
  float: left;
  @include px2res(margin-top, -8);
}
.home-main.hidden {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue